import * as React from 'react';
import { FlexRowCenter } from './Flexbox/Flexbox';
import styled from 'styled-components';
import { Loader } from './Loader';

export class FullscreenLoading extends React.Component {
  public render() {
    return (
      <Fullscreen>
        <Loader loading={true} />
      </Fullscreen>
    );
  }
}

const Fullscreen = styled(FlexRowCenter)`
  height: 100%;
  width: 100%;
  background: ${({ theme }) => theme.primary};
`;
